import moment from 'moment';
import { OfficeFieldWebInputTypeEnum } from '@pages/office/models/office-data.model';

export class DateTimeHelper {
  static ISO_8601_FORMAT = 'YYYY-MM-DD[T]00:00:00'; // ISO 8601 date-only; time intentionally fixed to 00:00:00 (ignored). Must stay in sync with backend date/time format.
  static MONTH_FORMAT = 'MM/YY';
  static TIME_FORMAT = 'HH:mm';

  static getJSDateFromFormattedString = (formattedString: string): Date => moment(formattedString, this.ISO_8601_FORMAT).toDate();
  static getJSDateFromString = (formattedString: string): Date => moment(formattedString).toDate();
  static getYearMonthFromString = (formattedString: string): Date => {
    const m = moment(formattedString);
    return new Date(m.year(), m.month());
  };

  static getJSDateFromDotNetDate = (dotNetDate: string): Date => {
    const match = /\/Date\((-?\d+)(?:[+-]\d+)?\)\//.exec(dotNetDate);
    return match ? new Date(parseInt(match[1], 10)) : null;
  };

  static getDBValue = (value: moment.MomentInput): string => moment(value).format(this.ISO_8601_FORMAT);

  static getFormattedValue = (value: moment.MomentInput, format: string): string => moment(value).format(format);

  static isInvalidDate = (value: string): boolean => {
    const date = new Date(value);
    return isNaN(date.getTime());
  };

  static isSameDate = (left: moment.MomentInput, right: moment.MomentInput): boolean => moment(left).isSame(right);

  static getLocaleTime = (value: moment.MomentInput): string => moment(value).format('LT');
  static getTimeFormatted = (value: moment.MomentInput): string => moment(value).format(this.TIME_FORMAT);

  static formatDateByInputType = (value: string, webInputType: string, mask: string, defaultDateFormat: string): string => {
    const format = mask || (webInputType === OfficeFieldWebInputTypeEnum.month ? DateTimeHelper.MONTH_FORMAT : defaultDateFormat);
    const date = this.getJSDateFromString(value);
    return this.getFormattedValue(date, format.toLocaleUpperCase());
  };
}
